// Use Vite env variables in the browser. Vite exposes `import.meta.env`.
const API_URL = (import.meta as any).env?.VITE_API_URL || 'http://localhost:3041/v1';

export const listGroupTours = async () => {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('admin_token') : null;
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const url = `${API_URL}/group-tours`;
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  if (!response.ok) throw new Error(`Failed to fetch group tours: ${response.status} ${response.statusText}`);
  const json = await response.json();
  return json;
};

export const getGroupTour = async (id: string) => {
  const response = await fetch(`${API_URL}/group-tours/${id}`);
  if (!response.ok) throw new Error('Failed to fetch group tour');
  return response.json();
};

export const createGroupTour = async (data: any) => {
  const options: RequestInit = {
    method: 'POST',
    headers: {},
  };
  const adminToken = typeof localStorage !== 'undefined' ? localStorage.getItem('admin_token') : null;
  if (adminToken) (options.headers as Record<string, string>)['Authorization'] = `Bearer ${adminToken}`;
  if (data instanceof FormData) {
    // Let browser set Content-Type with boundary
    options.body = data as any;
  } else {
    options.headers = { ...options.headers, 'Content-Type': 'application/json' };
    options.body = JSON.stringify(data);
  }
  const response = await fetch(`${API_URL}/group-tours`, options);
  if (!response.ok) throw new Error('Failed to create group tour');
  return response.json();
};

export const updateGroupTour = async (id: string, data: any) => {
  const options: RequestInit = {
    method: 'PATCH',
    headers: {},
  };
  const adminToken2 = typeof localStorage !== 'undefined' ? localStorage.getItem('admin_token') : null;
  if (adminToken2) (options.headers as Record<string, string>)['Authorization'] = `Bearer ${adminToken2}`;
  if (data instanceof FormData) {
    options.body = data as any;
  } else {
    options.headers = { ...options.headers, 'Content-Type': 'application/json' };
    options.body = JSON.stringify(data);
  }
  const response = await fetch(`${API_URL}/group-tours/${id}`, options);
  if (!response.ok) throw new Error('Failed to update group tour');
  return response.json();
};

export const deleteGroupTour = async (id: string) => {
  const tokenDel = typeof localStorage !== 'undefined' ? localStorage.getItem('admin_token') : null;
  const headersDel: Record<string, string> = {};
  if (tokenDel) headersDel.Authorization = `Bearer ${tokenDel}`;
  const response = await fetch(`${API_URL}/group-tours/${id}`, {
    method: 'DELETE',
    headers: headersDel,
  });
  if (!response.ok) throw new Error('Failed to delete group tour');
  // Backend returns 204 No Content for successful deletes. Handle empty body gracefully.
  try {
    return await response.json();
  } catch (e) {
    return null;
  }
};
